export const cilPlaylistAdd = ["24 24","<path d='M12 7.125h9.75v1.5h-9.75v-1.5z'></path><path d='M8.25 12h13.5v1.5h-13.5v-1.5z'></path><path d='M8.25 16.875h13.5v1.5h-13.5v-1.5z'></path><path d='M9 7.125h-3v-3h-1.5v3h-3v1.5h3v3h1.5v-3h3v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-playlist-add.js
// module id = null
// module chunks = 